import { Component, OnInit, OnDestroy } from '@angular/core';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
// import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Observable, Observer } from "rxjs";
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent implements OnInit {

  formData: FormData;
  uploadFile: any;
  fileName: any;
  success: boolean;
  templateUrl: any;
  base64Image: any;
  vendorId: any;
  baseUrl;

  constructor(
    private router: Router,
    private foodcourtmenuService: FoodcourtmenuService,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    // private appStateSrv: AppStateProvider
    private appStateSrv: AppStateProvider,
    private sideNavService: SidenavService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    let parkId = localStorage.getItem("parkId") ?? 1;
    this.baseUrl = `${environment.apiBaseUrl}api/BlobStorage/DownloadTemplateFile?fileName=FoodCourtVendor_Menu_Bulk_Upload.xlsx`;
    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');

    // this.subscriptions.unsubscribe();
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.foodcourtmenuService.setExcelData(data);
        this.router.navigate(['/preview-bulk-upload-food-menu/' + this.vendorId]);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }

}
